import {
  ApiOutlined,
  ExperimentOutlined,
  InsertRowAboveOutlined,
  InsertRowBelowOutlined,
  InsertRowLeftOutlined,
  InsertRowRightOutlined,
  SafetyCertificateOutlined,
} from '@ant-design/icons';

export const READ = {
  MORE: 'Read More',
  LESS: 'Read Less',
};

export const MESSAGE = {
  READ: 'read',
  UNREAD: 'unread',
};

export const TOOLTIP = {
  EDIT: 'Edit',
  DELETE: 'Delete',
  MAINTAINANCEHISTORY: 'maintainance history',
  MOREINFO: 'more Info',
  MARKASREAD: 'Mark As Read',
  MARKASUNREAD: 'Mark As Un-Read',
  SETTINGS: 'Settings',
  CONFIGRATION: 'Configration',
  NOTIFICATION: 'Notification',
  PROFILE: 'Profile',
  GOTO: 'Go to',
};

export const NOTIFICATIONS = {
  LOGIN: {
    TYPE: 'login',
  },
  FORGET_PASSWORD: {
    TYPE: 'forgetPassword',
  },
  CHANGE_EMAIL: {
    TYPE: 'changeEmail',
  },
  PROFILE_CHANGED: {
    TYPE: 'profileChanged',
  },
  WELCOME: {
    TYPE: 'welcome',
  },
  NEW_USER: {
    TYPE: 'newUser',
  },
  MAKE_LEADER_TO_ME: {
    TYPE: 'makeLeaderOfBranchToMe',
  },
  MAKE_LEADER: {
    TYPE: 'makeLeaderOfBranch',
  },
  REMOVE_AS_LEADER_TO_ME: {
    TYPE: 'removeAsLeaderOfBranch',
  },
  REMOVE_AS_LEADER: {
    TYPE: 'removeLeaderOfBranch',
  },
  POSITION_REMOVE_TO_ME: {
    TYPE: 'removePositionToMe',
  },
  POSITION_REMOVE: {
    TYPE: 'removePosition',
  },
  NEW_POSITION_TO_ME: {
    TYPE: 'newPositionToMe',
  },
  NEW_POSITION: {
    TYPE: 'newPosition',
  },
  FORM_SUBMIT_TO_ME: {
    TYPE: 'formSubmitedByMe',
  },
  FORM_SUBMITED: {
    TYPE: 'formSubmited',
  },
  TICKET_MESSAGE: {
    TYPE: 'ticketMessage',
  },
  TICKET_NOTE_MENTION: {
    TYPE: 'ticketNoteMention',
  },
  NEW_TICKET_ASSIGNED_TO_ME: {
    TYPE: 'newTicketAssignedToMe',
  },
  NEW_TICKET_REPORTER_TO_ME: {
    TYPE: 'newTicketReporterToMe',
  },
  TICKET_NEW_REPORTER_ADDED: {
    TYPE: 'newTicketAReporterAdded',
  },
  TICKET_REMOVE_REPORTER_TO_ME: {
    TYPE: 'newTicketAReporterRemove',
  },
  TICKET_UNASSIGNED_TO_ME: {
    TYPE: 'newTicketUnassignedToMe',
  },
  NEW_TICKET_ASSIGNEE_ADDED: {
    TYPE: 'newTicketAssigneeAdded',
  },
  TICKET_ASSIGNEE_REMOVED: {
    TYPE: 'newTicketAssigned',
  },
  TICKET_REPORTER_REMOVED: {
    TYPE: 'newTicketAssigned',
  },
  NEW_TICKET_ATTACHMENT: {
    TYPE: 'ticketNewAttachment',
  },
  TICKET_ATTACHMENT_REMOVED: {
    TYPE: 'ticketAttachmentRemoved',
  },
  TICKET_MOVE: {
    TYPE: 'ticketMove',
  },
  TICKET_REMOVE: {
    TYPE: 'ticketRemove',
  },
  MASTER_CALIBRATION_DUE: {
    TYPE: 'masterCalibrationDue',
  },
  MASTER_CERTIFICATE_EXPIRED: {
    TYPE: 'masterCertificateExpired',
  },
};

export const NOTIFICATION_CATEGORY_MASTER = { label: 'Master', value: 'Master' };

export const USER_TYPE = {
  ADMIN: 'Admin',
  USER: 'User',
  MANAGER: 'Manager',
  SUPER_ADMIN: 'SuperAdmin',
};

export const DIRECTORY = {
  assets: 'assets',
  ticket: 'tickets',
  account: 'account',
  profiles: 'profiles',
  dynamicForm: 'dynamicForm',
  signature: 'signatures',
  masters: 'masters',
};

export const MODULES = {
  BRANCH_MASTER: 'branchMaster',
  EMPLOYEE_MASTER: 'employeeMaster',
  ROLE_MASTER: 'roleMaster',
  ACCOUNT_MASTER: 'accountMaster',
  ASSETS_MASTER: 'assetsMaster',
  TICKET_MASTER: 'ticketMaster',
  FORM_MASTER: 'formMaster',
  SETTINGS_MASTER: 'settingsMaster',
  CLASS_MASTER: 'classMaster',
  CATEGORY_MASTER: 'categoryMaster',
  NOTIFICATION_MASTER: 'notificationMaster',
  PERMISSION_MASTER: 'permission',
  STATUS_MASTER: 'statusMaster',
  INSPECTION_TYPE_MASTER: 'inspectionsTypeMaster',
  MAINTENANCE_TYPE_MASTER: 'maintenanceTypeMaster',
  SIGNATURE_MASTER: 'signatureMaster',
  EMAIL_CONFIGURE_MASTER: 'emailConfigureMaster',
  RECEIPT_MASTER: 'receiptMaster',
  PLANNING_MASTER: 'planningMaster',
  DASHBOARD_MASTER: 'dashboardMaster',
  BOARD_MASTER: 'boardMaster',
  COMPLETED_MASTER: 'completedMaster',
  BACKLOG_MASTER: 'backlogMaster',
  TIMELINE_MASTER: 'timelineMaster',
  SPRINT_MASTER: 'sprintMaster',
  FORM_HEADER_FOOTER_MASTER: 'formHeaderMaster',
  DRAFT_MASTER: 'draftMaster',
  FAVORITE_MASTER: 'favoriteMaster',
  INBOX_MASTER: 'inboxMaster',
  SENT_MASTER: 'sentMaster',
  RECEIVE_MASTER: 'receiveMaster',
  MEETING_MASTER: 'meetingMaster',
  COLLABORATION_MASTER: 'collaborationMaster',
  ORGANIZATION_SETTINGS_MASTER: 'organizationSettingsMaster',
  SOURCE_MASTER: 'sourceMaster',
  TAG_MASTER: 'tagMaster',
  MASTER_CENTRAL: 'masterCentral',
};

export const PERMISSIONS = {
  VIEW: 'allow_view',
  EDIT: 'allow_edit',
  DELETE: 'allow_delete',
  ADD: 'allow_add',
};

export const MEETING_STATUS = {
  SCHEDULED: 'scheduled',
  LIVE: 'live',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
};

export const MEETING_PARTICIPANT_RESPONSE = {
  PENDING: 'pending',
  ACCEPTED: 'accepted',
  DECLINED: 'declined',
};

export const PAGE_TITLE = {
  ACCOUNTS: 'Accounts',
  ACCOUNT: 'Account',
  BRANCH: 'Branch',
  ASSETS: 'Entities',
  ASSET: 'Entity',
  NOTIFICATIONS: 'Notification',
  CATEGORY: 'Category',
  CONFIGURATION: 'Configuration',
  ROLE: 'Role',
  EMPLOYEE: 'Employee',
  DASHBOARD: 'Dashboard',
  TICKET: 'Ticket',
  SPRINT_TICKET: 'Sprint Ticket',
  PROFILE: 'User Settings',
  FORM: 'Form',
  PERMISSIONS: 'Permission',
  BOARD: 'Board',
  BACKLOG: 'Backlog',
  COMPLETED: 'Completed',
  INBOX: 'Inbox',
  ORGANIZATION_SETTINGS: 'Organization Settings',
  MASTER_CENTRAL: 'Master Central',
  MASTER: 'Master',
};

export const DATE_SCENARIO = {
  DATEPICKER: 'datePicker',
  FORMULA: 'formula',
};

export const TIME_SCENARIO = {
  DATEPICKER: 'datePicker',
  FORMULA: 'formula',
};

export const TIME_PICKER = [
  { value: 'HH:mm', label: 'HH:mm' },
  { value: 'HH:mm:ss', label: 'HH:mm:ss' },
];
export const DATE = [
  { value: 'DD/MM/YYYY', label: 'DD/MM/YYYY' },
  { value: 'DD/MM/YY', label: 'DD/MM/YY' },
  { value: 'YYYY/MM/DD', label: 'YYYY/MM/DD' },
  { value: 'DD-MM-YYYY', label: 'DD-MM-YYYY' },
  { value: 'DD-MM-YY', label: 'DD-MM-YY' },
  { value: 'YYYY-MM-DD', label: 'YYYY-MM-DD' },
];

export const DATE_AND_TIME = [
  { value: 'DD/MM/YYYY HH:mm', label: 'DD/MM/YYYY HH:mm' },
  { value: 'DD/MM/YYYY HH:mm:ss', label: 'DD/MM/YYYY HH:mm:ss' },
  { value: 'DD/MM/YY HH:mm', label: 'DD/MM/YY HH:mm' },
  { value: 'DD/MM/YY HH:mm:ss', label: 'DD/MM/YY HH:mm:ss' },
  { value: 'YYYY/MM/DD HH:mm', label: 'YYYY/MM/DD HH:mm' },
  { value: 'YYYY/MM/DD HH:mm:ss', label: 'YYYY/MM/DD HH:mm:ss' },
  { value: 'DD-MM-YYYY HH:mm', label: 'DD-MM-YYYY HH:mm' },
  { value: 'DD-MM-YYYY HH:mm:ss', label: 'DD-MM-YYYY HH:mm:ss' },
  { value: 'DD-MM-YY HH:mm', label: 'DD-MM-YY HH:mm' },
  { value: 'DD-MM-YY HH:mm:ss', label: 'DD-MM-YY HH:mm:ss' },
  { value: 'YYYY-MM-DD HH:mm', label: 'YYYY-MM-DD HH:mm' },
  { value: 'YYYY-MM-DD HH:mm:ss', label: 'YYYY-MM-DD HH:mm:ss' },
];

export const PICKER_FIELDS = [
  'datePicker',
  'timePicker',
  'dateAndTime',
  'dateTimeRange',
  'dateAndTimeRange',
  'timeRange',
];

export const TIME_RANGE_FIELDS = {
  MIN: 'timeRange.min',
  MAX: 'timeRange.max',
  MIN_FORMULA: 'timeRange.minFormula',
  MAX_FORMULA: 'timeRange.maxFormula',
  DATE_SCENARIO: 'timeRange.dateScenario',
};

export const TIME_PICKER_FIELDS = {
  MIN: 'timePicker.min',
  MAX: 'timePicker.max',
  MIN_FORMULA: 'timePicker.minFormula',
  MAX_FORMULA: 'timePicker.maxFormula',
  DATE_SCENARIO: 'timePicker.dateScenario',
};
export const DATE_PICKER_FIELDS = {
  MIN: 'datePicker.min',
  MAX: 'datePicker.max',
  MIN_FORMULA: 'datePicker.minFormula',
  MAX_FORMULA: 'datePicker.maxFormula',
  DATE_SCENARIO: 'datePicker.dateScenario',
};
export const DATE_TIME_RANGE_FIELDS = {
  MIN: 'dateTimeRange.min',
  MAX: 'dateTimeRange.max',
  MIN_FORMULA: 'dateTimeRange.minFormula',
  MAX_FORMULA: 'dateTimeRange.maxFormula',
  DATE_SCENARIO: 'dateTimeRange.dateScenario',
  TIME_SCENARIO: 'dateTimeRange.timeScenario',
  MIN_TIME: 'dateTimeRange.minTime',
  MAX_TIME: 'dateTimeRange.maxTime',
  MIN_TIME_FORMULA: 'dateTimeRange.minTimeFormula',
  MAX_TIME_FORMULA: 'dateTimeRange.maxTimeFormula',
};

export const DATE_AND_TIME_RANGE_FIELDS = {
  MIN: 'dateAndTimeRange.min',
  MAX: 'dateAndTimeRange.max',
  MIN_FORMULA: 'dateAndTimeRange.minFormula',
  MAX_FORMULA: 'dateAndTimeRange.maxFormula',
  DATE_SCENARIO: 'dateAndTimeRange.dateScenario',
  TIME_SCENARIO: 'dateAndTimeRange.timeScenario',
  MIN_TIME: 'dateAndTimeRange.minTime',
  MAX_TIME: 'dateAndTimeRange.maxTime',
  MIN_TIME_FORMULA: 'dateAndTimeRange.minTimeFormula',
  MAX_TIME_FORMULA: 'dateAndTimeRange.maxTimeFormula',
};
export const DATE_AND_TIME_FIELDS = {
  MIN: 'dateAndTime.min',
  MAX: 'dateAndTime.max',
  MIN_FORMULA: 'dateAndTime.minFormula',
  MAX_FORMULA: 'dateAndTime.maxFormula',
  DATE_SCENARIO: 'dateAndTime.dateScenario',
  TIME_SCENARIO: 'dateAndTime.timeScenario',
  MIN_TIME: 'dateAndTime.minTime',
  MAX_TIME: 'dateAndTime.maxTime',
  MIN_TIME_FORMULA: 'dateAndTime.minTimeFormula',
  MAX_TIME_FORMULA: 'dateAndTime.maxTimeFormula',
};
export const FORMULA_FIELDS = [
  TIME_PICKER_FIELDS.MIN_FORMULA,
  TIME_PICKER_FIELDS.MAX_FORMULA,
  DATE_AND_TIME_FIELDS.MIN_FORMULA,
  DATE_AND_TIME_FIELDS.MAX_FORMULA,
  DATE_AND_TIME_FIELDS.MIN_TIME_FORMULA,
  DATE_AND_TIME_FIELDS.MAX_TIME_FORMULA,
  DATE_TIME_RANGE_FIELDS.MIN_FORMULA,
  DATE_TIME_RANGE_FIELDS.MAX_FORMULA,
  DATE_TIME_RANGE_FIELDS.MIN_TIME_FORMULA,
  DATE_TIME_RANGE_FIELDS.MAX_TIME_FORMULA,
  DATE_AND_TIME_RANGE_FIELDS.MIN_FORMULA,
  DATE_AND_TIME_RANGE_FIELDS.MAX_FORMULA,
  DATE_AND_TIME_RANGE_FIELDS.MIN_TIME_FORMULA,
  DATE_AND_TIME_RANGE_FIELDS.MAX_TIME_FORMULA,
  DATE_PICKER_FIELDS.MIN_FORMULA,
  DATE_PICKER_FIELDS.MAX_FORMULA,
  TIME_RANGE_FIELDS.MIN_FORMULA,
  TIME_RANGE_FIELDS.MAX_FORMULA,
];

export const STAGE = {
  BOARD: 'Board',
  BACKLOG: 'Backlog',
  COMPLETED: 'Completed',
};

export const TICKET_TYPE = {
  INSPECTION: 'Inspection',
  MAINTENANCE: 'Maintenance',
  BREAKDOWN: 'Breakdown',
};

export const PRIORITY = {
  HIGH: 'HIGH',
  VERY_HIGH: 'VERY_HIGH',
  NORMAL: 'NORMAL',
  VERY_NORMAL: 'VERY_NORMAL',
};

export const VIEW_TYPES = {
  DAILY: 'day',
  WEEKLY: 'week',
  MONTHLY: 'month',
  YEARLY: 'year',
};

export const CLASS_DATA_TYPE = [
  { label: 'String', value: 'string' },
  { label: 'Number', value: 'number' },
  { label: 'Date', value: 'date' },
  { label: 'Toggle', value: 'toggle' },
];

export const RECURRENCEOPTIONS = [
  { label: 'Daily', value: 'daily' },
  { label: 'Weekly', value: 'weekly' },
  { label: 'Monthly', value: 'monthly' },
  { label: 'Annual', value: 'annual' },
];

export const WEEKDAYS = [
  { label: 'Sunday', value: 0 },
  { label: 'Monday', value: 1 },
  { label: 'Tuesday', value: 2 },
  { label: 'Wednesday', value: 3 },
  { label: 'Thursday', value: 4 },
  { label: 'Friday', value: 5 },
  { label: 'Saturday', value: 6 },
];

export const TYPEOFDATE = [
  { label: 'Direct Date', value: 'date' },
  { label: 'Relative Date', value: 'relative' },
];

export const position = ['First', 'Second', 'Third', 'Fourth', 'Fifth', 'Last'];

export const day = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export const monthOptions = [
  { label: 'January', value: 0 },
  { label: 'February', value: 1 },
  { label: 'March', value: 2 },
  { label: 'April', value: 3 },
  { label: 'May', value: 4 },
  { label: 'June', value: 5 },
  { label: 'July', value: 6 },
  { label: 'August', value: 7 },
  { label: 'September', value: 8 },
  { label: 'October', value: 9 },
  { label: 'November', value: 10 },
  { label: 'December', value: 11 },
];

export const approvalTypeOptions = [
  { label: 'None', value: 'none' },
  { label: 'Location', value: 'location' },
  { label: 'QR Code', value: 'Qrcode' },
];

export const FILE_TYPE_OPTIONS = {
  IMAGE_UPLOADER: [
    { value: 'image/png', label: 'PNG (image/png)' },
    { value: 'image/jpg', label: 'JPG (image/jpg)' },
    { value: 'image/jpeg', label: 'JPEG (image/jpeg)' },
    { value: 'image/svg', label: 'SVG (image/svg)' },
  ],
  SINGLE_FILE_UPLOADER: [
    { value: 'application/pdf', label: 'PDF (application/pdf)' },
    { value: 'application/vnd.ms-excel', label: 'Excel (application/vnd.ms-excel)' },
    { value: 'application/x-zip-compressed', label: 'ZIP (application/x-zip-compressed)' },
  ],
};

export const comparisonMethod = [
  { label: 'Simple Comparison', value: 'Simple Comparison' },
  { label: 'Date-Based Comparison', value: 'Date-Based Comparison' },
];

export const formInfo = [
  'Title',
  'TicketType',
  'TicketTypeDate',
  'TicketTypeTime',
  'TicketTypeDateAndTime',
  'SubmissionTime',
  'SubmissionDate',
  'SubmissionDateAndTime',
  'PrintTime',
  'PrintDate',
  'PrintDateAndTime',
  'AssignedTo',
  'ReportBy',
  'SubmittedBy',
  'ApprovedBy',
  'FormZone',
  'TicketTypeTimeLabel',
];

export const statusMeta = {
  [MEETING_STATUS.SCHEDULED]: { color: 'default', label: 'Scheduled' },
  [MEETING_STATUS.LIVE]: { color: 'green', label: 'Live' },
  [MEETING_STATUS.COMPLETED]: { color: 'blue', label: 'Completed' },
  [MEETING_STATUS.CANCELLED]: { color: 'red', label: 'Cancelled' },
};

export const filterOptions = [
  { label: 'Automatic schedule', value: 'automatic_schedule' },
  { label: 'Upcoming', value: 'upcoming' },
  { label: 'Live', value: MEETING_STATUS.LIVE },
  { label: 'Past', value: 'past' },
  { label: 'Cancelled', value: MEETING_STATUS.CANCELLED },
  { label: 'All', value: 'all' },
];

export const googleCalendarSyncOptions = [
  { label: 'Tickets', key: 'syncTickets' },
  { label: 'Meetings', key: 'syncMeetings' },
  { label: 'Reminders', key: 'syncReminders' },
];

export const EVENT_TYPE = {
  TICKET: 'ticket',
  MEETING: 'meeting',
  REMINDER: 'reminder',
};

export const passAllRows = () => true;

export const textFilterParams = {
  maxNumConditions: 1,
  filterOptions: [
    { displayKey: 'contains', displayName: 'Contains', predicate: passAllRows, numberOfInputs: 1 },
    {
      displayKey: 'notContains',
      displayName: 'Not contains',
      predicate: passAllRows,
      numberOfInputs: 1,
    },
    { displayKey: 'equals', displayName: 'Equals', predicate: passAllRows, numberOfInputs: 1 },
    { displayKey: 'notEqual', displayName: 'Not equal', predicate: passAllRows, numberOfInputs: 1 },
    {
      displayKey: 'startsWith',
      displayName: 'Starts with',
      predicate: passAllRows,
      numberOfInputs: 1,
    },
    { displayKey: 'endsWith', displayName: 'Ends with', predicate: passAllRows, numberOfInputs: 1 },
  ],
  textMatcher: passAllRows,
};

export const numberFilterParams = {
  maxNumConditions: 1,
  filterOptions: [
    { displayKey: 'equals', displayName: 'Equals', predicate: passAllRows, numberOfInputs: 1 },
    { displayKey: 'notEqual', displayName: 'Not equal', predicate: passAllRows, numberOfInputs: 1 },
    { displayKey: 'lessThan', displayName: 'Less than', predicate: passAllRows, numberOfInputs: 1 },
    {
      displayKey: 'greaterThan',
      displayName: 'Greater than',
      predicate: passAllRows,
      numberOfInputs: 1,
    },
  ],
  suppressAndOrCondition: true,
};

export const TICKET_DATE_FILTER_PARAMS = {
  maxNumConditions: 1,
  filterPlaceholder: 'dd/mm/yy',
  inRangeFloatingFilterDateFormat: 'dd/mm/yy',
  filterOptions: [
    { displayKey: 'equals', displayName: 'Equals', predicate: () => true, numberOfInputs: 1 },
    { displayKey: 'lessThan', displayName: 'Before', predicate: () => true, numberOfInputs: 1 },
    { displayKey: 'greaterThan', displayName: 'After', predicate: () => true, numberOfInputs: 1 },
    { displayKey: 'inRange', displayName: 'Between', predicate: () => true, numberOfInputs: 2 },
  ],
};

export const menuNameFilterParams = {
  maxNumConditions: 1,
  filterOptions: [
    { displayKey: 'contains', displayName: 'Contains', predicate: passAllRows, numberOfInputs: 1 },
    {
      displayKey: 'notContains',
      displayName: 'Not contains',
      predicate: passAllRows,
      numberOfInputs: 1,
    },
    { displayKey: 'equals', displayName: 'Equals', predicate: passAllRows, numberOfInputs: 1 },
    { displayKey: 'notEqual', displayName: 'Not equal', predicate: passAllRows, numberOfInputs: 1 },
    {
      displayKey: 'startsWith',
      displayName: 'Starts with',
      predicate: passAllRows,
      numberOfInputs: 1,
    },
    { displayKey: 'endsWith', displayName: 'Ends with', predicate: passAllRows, numberOfInputs: 1 },
  ],
  textMatcher: passAllRows,
};

export const sortOptions = [
  { label: 'Ticket Title', value: 'title' },
  { label: 'Created Time', value: 'createdAt' },
  { label: 'Schedule Date Time', value: 'schedule_date_time' },
  { label: 'Finish Date Time', value: 'finish_date_time' },
];

export const REMINDER_TAB_OPTIONS = [
  { label: 'Automatic Schedule', value: 'automatic_schedule' },
  { label: 'Upcoming', value: 'upcoming' },
  { label: 'Past', value: 'past' },
  { label: 'All', value: 'all' },
];

export const DEFAULT_TICKET_LAYOUT_FIELDS = [
  { key: 'lateLabel', label: 'LATE Label', is_visible: true },
  { key: 'ticketCode', label: 'Ticket Code / Number', is_visible: true },
  { key: 'account', label: 'Account', is_visible: true },
  { key: 'entity', label: 'Entity', is_visible: true },
  { key: 'priority', label: 'Priority', is_visible: true },
  { key: 'metaTags', label: 'Meta Tags', is_visible: true },
  { key: 'reporter', label: 'Reporter', is_visible: true },
  { key: 'assignee', label: 'Assignee', is_visible: true },
  { key: 'description', label: 'Description', is_visible: true },
  { key: 'startDate', label: 'Start Date', is_visible: true },
  { key: 'endDate', label: 'End Date', is_visible: true },
  { key: 'formsApproved', label: 'Forms Approved', is_visible: true },
];

export const getDefaultTicketLayoutFields = () =>
  DEFAULT_TICKET_LAYOUT_FIELDS.map((field) => ({ ...field }));

export const buildTicketLayoutVisibilityMap = (fields = []) => {
  const defaultMap = getDefaultTicketLayoutFields().reduce((acc, field) => {
    acc[field.key] = true;
    return acc;
  }, {});

  if (!Array.isArray(fields) || fields.length === 0) {
    return defaultMap;
  }

  return fields.reduce((acc, field) => {
    if (field?.key) {
      acc[field.key] = Boolean(field?.is_visible);
    }
    return acc;
  }, defaultMap);
};

export const BORDER_MENU_ITEMS = [
  { key: 'top', label: 'Top border' },
  { key: 'bottom', label: 'Bottom border' },
  { key: 'left', label: 'Left border' },
  { key: 'right', label: 'Right border' },
  { type: 'divider' },
  { key: 'all', label: 'All borders' },
  { type: 'divider' },
  { key: 'clear', label: 'Clear borders' },
];

export const INSERT_MENU_ITEMS = [
  { key: 'row_above', label: 'Insert row above', icon: <InsertRowAboveOutlined /> },
  { key: 'row_below', label: 'Insert row below', icon: <InsertRowBelowOutlined /> },
  { type: 'divider' },
  { key: 'col_left', label: 'Insert column left', icon: <InsertRowLeftOutlined /> },
  { key: 'col_right', label: 'Insert column right', icon: <InsertRowRightOutlined /> },
];

export const MERGE_MENU_ITEMS = [
  { key: 'merge_center', label: 'Merge & Center' },
  { key: 'merge_across', label: 'Merge Across' },
  { type: 'divider' },
  { key: 'merge_cells', label: 'Merge Cells' },
  { key: 'unmerge_cells', label: 'Unmerge Cells' },
];

/**
 * Report spreadsheet cell fonts — system/web-safe allowlist only.
 * PDF export uses PDF_REPORT_FONT (Roboto) for all styled cells; see applyCellStylesToPdfCell.
 * Excel uses font.name; fidelity depends on fonts installed on the machine opening the file.
 */

export const REPORT_FONT_OPTIONS = [
  { label: 'Arial', value: 'Arial' },
  { label: 'Calibri', value: 'Calibri' },
  { label: 'Times New Roman', value: 'Times New Roman' },
  { label: 'Verdana', value: 'Verdana' },
  { label: 'Georgia', value: 'Georgia' },
  { label: 'Courier New', value: 'Courier New' },
];

export const ALLOWED_REPORT_FONTS = new Set(REPORT_FONT_OPTIONS.map((o) => o.value));

/** Only family registered in pdfMake (Preview.js). */
export const PDF_REPORT_FONT = 'Roboto';

const LEGACY_FONT_ALIASES = {
  Helvetica: 'Arial',
  Roboto: 'Arial',
  helvetica: 'Arial',
  roboto: 'Arial',
};

/**
 * @param {string | undefined | null} name
 * @returns {string | undefined} Allowed font name, or undefined if empty/unknown
 */
export const normalizeReportFontFamily = (name) => {
  if (name == null || typeof name !== 'string') return undefined;
  const trimmed = name.trim();
  if (!trimmed) return undefined;

  if (ALLOWED_REPORT_FONTS.has(trimmed)) return trimmed;

  const alias = LEGACY_FONT_ALIASES[trimmed];
  if (alias && ALLOWED_REPORT_FONTS.has(alias)) return alias;

  return undefined;
};

// ── Master Central ──────────────────────────────────────────────────────────

export const MASTER_DATE_FORMAT = 'DD/MM/YYYY';

export const MASTER_STANDARD_LEVEL_OPTIONS = [
  { label: 'Reference standard', value: 'reference' },
  { label: 'Working standard', value: 'working' },
  { label: 'Check standard', value: 'check' },
];

// Suggestions only; the unit field stays free text.
export const MASTER_UNIT_OPTIONS = [
  { label: 'Pressure', options: ['bar', 'mbar', 'kPa', 'MPa', 'psi', 'kg/cm²'].map((value) => ({ value })) },
  { label: 'Temperature', options: ['°C', '°F', 'K'].map((value) => ({ value })) },
  { label: 'Electrical', options: ['mA', 'A', 'mV', 'V', 'Ω', 'kΩ'].map((value) => ({ value })) },
  { label: 'Other', options: ['%RH', 'Hz', 'kg', 'g', 'mm'].map((value) => ({ value })) },
];

export const MASTER_QUANTITY_OPTIONS = [
  'Pressure',
  'Temperature',
  'Current',
  'Voltage',
  'Resistance',
  'Mass',
  'Length',
  'Frequency',
  'Humidity',
].map((q) => ({ label: q, value: q }));

export const MASTER_PRESSURE_TYPE_OPTIONS = [
  { label: 'Gauge', value: 'gauge' },
  { label: 'Absolute', value: 'absolute' },
  { label: 'Differential', value: 'differential' },
];

export const MASTER_USED_AS_OPTIONS = [
  { label: 'Measuring standard', value: 'measuring_standard' },
  { label: 'Source (bath / furnace / pressure)', value: 'source' },
  { label: 'Both', value: 'both' },
];
export const MASTER_USED_AS_INFO =
  'What this master provides in a calibration. It decides which of its values the Uncertainty column ' +
  'uses: a measuring standard contributes its certificate U; a source contributes its uniformity and stability.';
export const MASTER_RANGE_SPEC_INFO =
  '± in the range unit, from the datasheet or type approval. Used by the automatic Uncertainty column; ' +
  'leave blank if not recorded — a blank value simply contributes nothing.';

export const MASTER_CALIBRATION_SOURCE_OPTIONS = [
  { label: 'External accredited lab', value: 'external_accredited_lab' },
  { label: 'In-house', value: 'in_house' },
  { label: 'Manufacturer', value: 'manufacturer' },
];

export const MASTER_OWNERSHIP_OPTIONS = [
  { label: 'Owned', value: 'owned' },
  { label: 'Hired', value: 'hired' },
  { label: 'Borrowed', value: 'borrowed' },
];

export const MASTER_USED_AT_OPTIONS = [
  { label: 'In lab', value: 'lab' },
  { label: 'On site', value: 'site' },
  { label: 'In lab and on site', value: 'both' },
];

export const MASTER_CONDITION_OPTIONS = [
  { label: 'New', value: 'New' },
  { label: 'Used', value: 'Used' },
  { label: 'Reconditioned', value: 'Reconditioned' },
];

// Availability = set by a person (stored `status`); 'out_of_service' is legacy, read as under_repair.
export const MASTER_AVAILABILITY_META = {
  in_service: { label: 'Available', color: 'green', description: 'Can be used on forms' },
  sent_for_calibration: { label: 'Away for calibration', color: 'geekblue', description: 'At the lab for its calibration' },
  under_repair: { label: 'Under repair', color: 'orange', description: 'Faulty or being fixed' },
  quarantined: { label: 'Quarantined', color: 'purple', description: 'Suspect — don’t use until checked' },
  retired: { label: 'Retired', color: 'default', description: 'No longer in use, kept for records' },
};

export const MASTER_AVAILABILITY_OPTIONS = Object.entries(MASTER_AVAILABILITY_META).map(
  ([value, meta]) => ({ label: meta.label, value, description: meta.description, title: '' })
);

// Change Log values written before the rename.
export const MASTER_AVAILABILITY_LOG_OPTIONS = [
  ...MASTER_AVAILABILITY_OPTIONS,
  { label: 'Out of service', value: 'out_of_service' },
];

// Calibration = worked out by the backend from the current certificate (masterStatus.js).
export const MASTER_CALIBRATION_STATUS_META = {
  valid: { label: 'Valid', color: 'green' },
  due_soon: { label: 'Due soon', color: 'gold' },
  expired: { label: 'Expired', color: 'red' },
  no_certificate: { label: 'No certificate', color: 'default' },
};

export const MASTER_CALIBRATION_STATUS_OPTIONS = Object.entries(MASTER_CALIBRATION_STATUS_META).map(
  ([value, meta]) => ({ label: meta.label, value })
);

// Masters list: the groups inside the single Filters drawer, in display order.
export const MASTER_FILTER_GROUPS = [
  { key: 'categories', label: 'Category', placeholder: 'Select category' },
  { key: 'classes', label: 'Class', placeholder: 'Select class' },
  { key: 'availabilities', label: 'Availability', placeholder: 'Select availability' },
  { key: 'calibrations', label: 'Calibration', placeholder: 'Select calibration status' },
];
export const MASTER_FILTERS_EMPTY = { categories: [], classes: [], availabilities: [], calibrations: [] };

export const MASTER_AVAILABILITY_INFO =
  'Set by a person: can this master be used right now? Only Available masters with a valid certificate are offered as Ready on forms.';
export const MASTER_CALIBRATION_INFO =
  'Worked out from the current certificate: Valid, Due soon (within Alert Before Due), Expired or No certificate.';

export const MASTER_CERTIFICATE_STATUS_META = {
  current: { label: 'Current', color: 'blue' },
  superseded: { label: 'Superseded', color: 'default' },
  not_fit: { label: 'Not fit', color: 'red' },
};

export const MASTER_AS_FOUND_OPTIONS = [
  { label: 'In tolerance', value: 'in_tolerance' },
  { label: 'Out of tolerance', value: 'out_of_tolerance' },
];

export const MASTER_YES_NO_OPTIONS = [
  { label: 'Yes', value: true },
  { label: 'No', value: false },
];

export const MASTER_DETAIL_TAB_KEYS = ['certificates', 'changes', 'usage', 'checks'];

export const MASTER_STEP_TITLES = ['Master Details', 'Measurement', 'Calibration & Upkeep'];

export const MASTER_STEP_INFO = [
  'Let’s start with the master’s details',
  'What this master measures and which instruments it can calibrate',
  'How this master is kept valid and looked after',
];

export const MASTER_STEP_FIELDS = [
  ['name', 'master_code', 'manufacturer', 'model', 'serial_no', 'standard_level', 'used_as', 'components'],
  ['measured_quantity', 'pressure_type', 'ranges', 'reading_points', 'decision_rule', 'entity_class_ids', 'entity_category_ids'],
  [
    'calibration_source', 'preferred_lab', 'calibration_interval_months', 'alert_before_days',
    'intermediate_check', 'custodian_id', 'location', 'ownership', 'used_at',
    'date_received', 'in_service_from', 'condition_received', 'status', 'status_reason',
    'restriction_note',
  ],
];

// Add Master only: optional step 4 with the lab's latest certificate (Edit keeps 3 steps).
export const MASTER_CERTIFICATE_STEP = {
  title: 'Current Certificate',
  info: 'The lab’s latest certificate for this master',
  fields: ['add_certificate', 'certificate'],
};
export const MASTER_ADD_CERTIFICATE_INFO =
  'Optional. Skip it if the certificate isn’t to hand — record it later from the master’s page.';

export const MASTER_STEP_NOTE =
  'Please fill all required fields which marked with *, and click on a next button to proceed further';
export const MASTER_LAST_STEP_NOTE = (buttonText) =>
  `Please fill all required fields which are marked with *, and click on a ${buttonText} button to proceed.`;

// Row lists: desktop = one grid row (span of 24, the rest is the delete button); phone = a card with labelled fields.
export const MASTER_COMPONENT_COLUMNS = [
  { key: 'component', label: 'Component', span: 9, phoneSpan: 24 },
  { key: 'model', label: 'Model', span: 6, phoneSpan: 12 },
  { key: 'serial', label: 'Serial No.', span: 6, phoneSpan: 12 },
];
// Acceptance limit = datasheet parts {value, basis} joined by + or or; 'fixed' label is the range's unit.
export const MASTER_LIMIT_BASIS_OPTIONS = [
  { value: 'pct_reading', label: '% of reading', short: '% rdg' },
  { value: 'pct_span', label: '% of span', short: '% span' },
  { value: 'pct_fs', label: '% of full scale', short: '% FS' },
  { value: 'fixed', label: null, short: null },
  { value: 'digits', label: 'digits', short: 'digits' },
];
export const MASTER_LIMIT_COMBINE_OPTIONS = [
  { value: 'add', label: '+', menuLabel: '+ — added together' },
  { value: 'greater', label: 'or', menuLabel: 'or — whichever is greater' },
];
export const MASTER_LIMIT_MAX_PARTS = 3;
// Reading points a form can fill into its reading table when this master is picked.
export const MASTER_READING_POINTS_TITLE = 'Reading Points';
export const MASTER_READING_POINTS_ADD = 'Segment';
export const MASTER_READING_POINTS_INFO =
  'Points a form can fill into its reading table when this master is picked (the person is asked first). ' +
  'Each From–To–Step segment must lie inside one of the ranges above. Shared ends count once, and a step that misses the end adds the end. Up to 50 points.';
export const MASTER_LIMIT_INFO =
  'Enter the limit exactly as the datasheet writes it. % of span uses To − From; % of full scale uses the larger range end. ' +
  'Digits are converted with the resolution (2 digits × 0.001 = ±0.002). ' +
  'If the spec changes across the scale — e.g. 2 % / 1 % / 2 % of span — enter each band as its own range.';
export const MASTER_DECISION_RULE_OPTIONS = [
  { value: 'simple', label: 'Simple acceptance' },
  { value: 'guard_band', label: 'Guard band' },
];
export const MASTER_DECISION_RULE_INFO =
  'How certificate results are judged against the limit. Simple acceptance: a point passes when its error is within the limit. ' +
  'Guard band: a point passes only when error + uncertainty stays within the limit (ILAC-G8).';

export const MASTER_CERTIFICATE_STEP_TITLES = ['Certificate', 'Results & Review'];

export const MASTER_RECORD_CALIBRATION_TITLE = 'Record New Calibration';
export const MASTER_PDF_MISSING_LABEL = 'PDF missing';

export const MASTER_CERTIFICATE_FILE_INFO =
  'Optional. Without it the certificate is flagged PDF missing until someone attaches it from the master’s page.';
export const MASTER_GUARD_BAND_NEEDS_U =
  'Guard band needs the uncertainty value — points without U can’t be judged against the limit.';

// Change Log tab: filter options, event tags, field labels.
export const MASTER_CHANGE_LOG_FILTER_OPTIONS = [
  { value: '', label: 'All changes' },
  { value: 'master', label: 'Master edits' },
  { value: 'certificates', label: 'Certificates' },
];
export const MASTER_CHANGE_TYPE_META = {
  created: { label: 'Created', color: 'gold' },
  edited: { label: 'Edited', color: 'default' },
  certificate_recorded: { label: 'Calibration recorded', color: 'green' },
  pdf_attached: { label: 'PDF attached', color: 'blue' },
};
export const MASTER_CHANGE_BACKFILLED_INFO =
  'Added afterwards from the saved master and certificate records, at their original dates. Edits made before the Change Log existed could not be recovered.';
export const MASTER_CHANGE_FIELD_LABELS = {
  name: 'Master Name',
  master_code: 'Master ID',
  manufacturer: 'Manufacturer',
  model: 'Model',
  serial_no: 'Serial No.',
  standard_level: 'Standard Level',
  components: 'Components',
  measured_quantity: 'Measured Quantity',
  used_as: 'Used As',
  pressure_type: 'Pressure Type',
  ranges: 'Range',
  decision_rule: 'Decision Rule',
  entity_class_ids: 'Entity Classes',
  entity_category_ids: 'Entity Categories',
  calibration_source: 'Calibration Source',
  preferred_lab: 'Preferred Lab',
  calibration_interval_months: 'Calibration Interval',
  alert_before_days: 'Alert Before Due',
  intermediate_check: 'Intermediate Checks',
  custodian_id: 'Custodian',
  location: 'Location',
  ownership: 'Ownership',
  used_at: 'Used At',
  date_received: 'Date Received',
  in_service_from: 'In Service From',
  condition_received: 'Condition When Received',
  manual_file: 'Manual / Datasheet',
  status: 'Status',
  status_reason: 'Status Reason',
  restriction_note: 'Restriction Note',
};

export const MASTER_CERTIFICATE_IDENTITY_INFO =
  'Optional. As printed on the lab’s certificate.';

export const MASTER_CERTIFICATE_STEP_INFO = [
  'Copy the details from the lab’s certificate',
  'Enter what the lab found, then review the certificate',
];

export const MASTER_CERTIFICATE_STEP_FIELDS = [
  ['serial_on_certificate', 'model_on_certificate', 'certificate_no', 'lab', 'accreditation_no', 'calibrated_on', 'valid_till'],
  ['as_found', 'adjusted_by_lab', 'results', 'reviewed_by', 'fit_for_use'],
];

// The first label gets the master's unit appended, e.g. "Nominal (bar)".
export const MASTER_RESULT_COLUMNS = [
  { key: 'nominal', label: 'Nominal', span: 5, phoneSpan: 12 },
  { key: 'master_reading', label: 'Master Reading', span: 5, phoneSpan: 12 },
  { key: 'correction', label: 'Correction (auto)', span: 5, phoneSpan: 24 },
  { key: 'uncertainty', label: 'U (±)', span: 4, phoneSpan: 12 },
  { key: 'k', label: 'k', span: 3, phoneSpan: 12 },
];

// Read-only results table in the certificate view.
export const MASTER_RESULT_TABLE_COLUMNS = [
  { title: 'Nominal', dataIndex: 'nominal' },
  { title: 'Master Reading', dataIndex: 'master_reading' },
  { title: 'Correction', dataIndex: 'correction' },
  { title: 'U (±)', dataIndex: 'uncertainty' },
  { title: 'k', dataIndex: 'k' },
];

// Appended in the certificate view when the points were judged against acceptance limits.
export const MASTER_RESULT_ALLOWED_COLUMN = { title: 'Allowed (±)', dataIndex: 'allowed_error' };

// ── Master field in forms (Calibration / Laboratory) ─────────────────────────
export const MASTER_FIELD_DATA_TYPE = 'master';
export const MASTER_FIELD_PLACEHOLDER = 'Pick a master';
export const MASTER_FIELD_INFO =
  'While filling, the person picks a master instrument from Master Central. Masters mapped to the ticket ' +
  'instrument’s class or category are offered first; unfit masters warn but never block. Renaming this field ' +
  'orphans any “Auto-fill from master” references to it.';
export const MASTER_ENTITY_CLASSES_INFO =
  'The exact instrument types this master calibrates — these rank first in the form picker.';
export const MASTER_ENTITY_CATEGORIES_INFO =
  'Broad families. A master matching the instrument’s class AND category shows on top; matching either still shows.';
export const MASTER_PICKER_GROUP_LABELS = { ready: 'Ready', attention: 'Needs attention' };
export const MASTER_PICKER_NO_ENTITY_NOTE = 'Ticket has no instrument — showing all masters';
export const MASTER_PICKER_NO_MAPPING_NOTE = 'No masters are mapped to this instrument — showing all masters';
export const MASTER_PICKER_EMPTY = 'No masters in Master Central yet';
export const MASTER_PICKER_LOAD_ERROR = 'Masters could not be loaded. Check the connection and open the form again.';
// rank: 3 = class + category, 2 = class, 1 = category
export const MASTER_MATCH_HINTS = { 3: 'matches class + category', 2: 'matches class', 1: 'matches category' };
export const MASTER_WARNING_NOTE =
  'You can still submit; the warning and your confirmation are saved with the result.';
// Last line of the warning on a cell auto-filled from a picked master that breaks the field's rules.
export const MASTER_AUTO_FILL_WARNING_NOTE =
  "Filled in automatically from the picked master. You can still submit; if it's wrong, correct the master in Master Central.";
export const MASTER_REMOVED_REASON = 'This master was removed — pick another';
export const MASTER_RESTRICTION_PREFIX = 'Restriction:';
export const MASTER_CONFIRM_TITLE = 'Check the masters used';
export const MASTER_CONFIRM_INTRO = (count) =>
  `${count} of the masters picked on this form ${count === 1 ? 'needs' : 'need'} your confirmation.`;
export const MASTER_CONFIRM_QUESTION = 'Submit anyway?';
export const MASTER_CONFIRM_BACK = 'Go back';
export const MASTER_CONFIRM_OK = 'Submit anyway';
// Changing or removing a master that is already picked (auto or by hand) asks first.
export const MASTER_CHANGE_CONFIRM = {
  changeTitle: 'Change the master?',
  changeBody:
    'Changing the master replaces all values filled from it (certificate no., valid till, U, k, accuracy…) and recalculates the uncertainty. Readings you typed stay.',
  change: 'Change master',
  clearTitle: 'Remove the master?',
  clearBody:
    'Removing the master empties all values filled from it (certificate no., valid till, U, k, accuracy…), so the uncertainty stays blank until another master is picked. Readings you typed stay.',
  clear: 'Remove master',
  keep: 'Keep current master',
};
// "Auto-fill from → Master field…": what a field can take from the picked master, by field type.
export const MASTER_AUTO_FILL_ATTRIBUTES = [
  { value: 'masterId', label: 'Master ID', types: ['text'] },
  { value: 'name', label: 'Name', types: ['text'] },
  { value: 'makeModel', label: 'Make / Model', types: ['text'] },
  { value: 'serial', label: 'Serial', types: ['text'] },
  { value: 'certificateNo', label: 'Certificate no.', types: ['text'] },
  { value: 'lab', label: 'Lab', types: ['text'] },
  { value: 'accreditation', label: 'Lab accreditation no.', types: ['text'] },
  { value: 'calibratedOn', label: 'Calibrated on', types: ['text', 'datepicker'] },
  { value: 'validTill', label: 'Valid till', types: ['text', 'datepicker'] },
  { value: 'uncertainty', label: 'U (±)', types: ['text', 'number'] },
  { value: 'k', label: 'k', types: ['text', 'number'] },
  { value: 'accuracy', label: 'Accuracy (±)', types: ['text', 'number'] },
  { value: 'resolution', label: 'Resolution', types: ['text', 'number'] },
  { value: 'drift', label: 'Drift (±)', types: ['text', 'number'] },
  { value: 'uniformity', label: 'Uniformity (±)', types: ['text', 'number'] },
  { value: 'stability', label: 'Stability (±)', types: ['text', 'number'] },
  // Internal (hidden from the designer dropdown): 1 = counts in Ue, 0 = pure source.
  { value: 'role', label: 'Counts in Ue (1/0)', types: ['number'], hidden: true },
  // Internal per-row values (Uncertainty column's in-table columns): resolved at the row's point.
  { value: 'u_at_point', label: 'u at point', types: ['number'], hidden: true },
  { value: 'accuracy_at_point', label: 'Accuracy at point', types: ['number'], hidden: true },
];
export const MASTER_AUTO_FILL_INFO =
  'Fills when a master is picked while filling, then locks. U and k come from the certificate row with the ' +
  'largest uncertainty; Accuracy, Resolution, Drift, Uniformity and Stability come from the master’s ' +
  'ranges (worst case over the ranges the readings fall in). Date fields offer the certificate dates.';
export const MASTER_AUTO_FILL_NO_FIELDS =
  'Add a Master field to this form first, then pick it here.';
// Master field "Fill reading points into": a Number column of a reading table.
export const MASTER_READING_TARGET_LABEL = 'Fill reading points into';
export const MASTER_READING_TARGET_INFO =
  'When a master with reading points is picked while filling, the person is asked whether to fill the points ' +
  'into this column, top to bottom. Rows are never added and the values stay editable. Leave empty to turn it off.';
export const MASTER_READING_TARGET_EMPTY = 'No Number column in a reading table yet.';
export const MASTER_READING_TARGET_GONE = 'This column is no longer in a reading table — pick another or clear it';
export const MASTER_READING_TARGET_TAKEN = (master) => `Already used by ${master} — each column takes one master's points`;
export const MASTER_READING_TARGET_USED_BY = (master) => `used by ${master}`;
// While filling: the ask dialog and the links under the master cell.
export const MASTER_READING_FILL_TITLE = 'Fill reading points';
export const MASTER_READING_FILL_STEP_TITLE = (index, total) => `Fill reading points (${index} of ${total})`;
export const MASTER_READING_FILL_OK = 'Fill';
export const MASTER_READING_FILL_SKIP = 'Skip';
// [{ text, strong? }] — "Fill 9 reading points from DPC-40 into Applied (bar)?"
export const MASTER_READING_FILL_QUESTION = (count, master, column) => [
  { text: `Fill ${count} reading ${count === 1 ? 'point' : 'points'} from ` },
  { text: master, strong: true },
  { text: ' into ' },
  { text: column, strong: true },
  { text: '?' },
];
export const MASTER_READING_FILL_FIT_NOTE_MORE = (fit, rest) =>
  `Only ${fit} added ${fit === 1 ? 'row is' : 'rows are'} left for them. Add rows later to fill the other ${rest}.`;
export const MASTER_READING_FILL_ADD_ROW_FIRST = 'Add rows with “+ Add row” under the table first.';
export const MASTER_READING_FILL_DONE = (count) => `${count} reading ${count === 1 ? 'point' : 'points'} filled`;
export const MASTER_READING_FILL_FIT_NOTE = (rows, rest) =>
  `The table has ${rows} ${rows === 1 ? 'row' : 'rows'}, so the first ${rows} ${rows === 1 ? 'point fits' : 'points fit'}. ` +
  `Add rows later to fill the other ${rest}.`;
export const MASTER_READING_FILL_OVERWRITE = (column, count) =>
  `${column} already has values in ${count} ${count === 1 ? 'row' : 'rows'}. Filling replaces them.`;
export const MASTER_READING_FILL_LINK = 'Fill reading points';
export const MASTER_READING_FILL_REMAINING_LINK = 'Fill remaining points';
export const MASTER_READING_FILL_NOT_FIT = (count) => `${count} more ${count === 1 ? 'point' : 'points'} didn’t fit`;
// Certificate tokens per master field: @<label>.<attribute> (the server fills them from the Submit record).
export const MASTER_CERTIFICATE_TOKEN_ATTRS = [
  'Name', 'ID', 'MakeModel', 'Serial', 'CertificateNo', 'Lab', 'Accreditation', 'CalibratedOn', 'ValidTill', 'U', 'k',
];
export const MASTERS_USED_TITLE = 'Masters Used';
export const MASTERS_USED_COLUMNS = [
  { title: 'Field', dataIndex: 'field' },
  { title: 'Master', dataIndex: 'master' },
  { title: 'Certificate No.', dataIndex: 'certificateNo' },
  { title: 'Valid Till', dataIndex: 'validTill' },
  { title: 'U (±)', dataIndex: 'uncertainty' },
  { title: 'k', dataIndex: 'k' },
  { title: 'Warnings Confirmed', dataIndex: 'warnings' },
];

// ---------- Uncertainty column (NABL-accredited organisations) ----------
export const UNCERTAINTY_FLAG_KEY = 'uncertainty';
export const UNCERTAINTY_DEFAULT_BASE_LABEL = 'Ue';
export const UNCERTAINTY_BASE_LABEL_CHOICES = ['Ue', 'U', 'Uncertainty', 'Expanded Uncertainty'];
export const UNCERTAINTY_DEFAULT_HEADER = (k) => `Expanded Unc. Ue (k=${k})`;
// Automatic k: the heading cannot promise one k, and the k column states it per row.
export const UNCERTAINTY_AUTO_UE_HEADER = 'Expanded Unc. Ue (95.45 %)';
export const UNCERTAINTY_K_HEADER = 'Coverage factor k';
export const UNCERTAINTY_DEFAULT_K = 2;
export const UNCERTAINTY_DEFAULT_ROUNDING = { mode: 'significant', digits: 2 };
export const UNCERTAINTY_ROUNDING_MODES = [
  { value: 'significant', label: 'Significant digits, rounded up' },
  { value: 'decimals', label: 'Decimal places, rounded up' },
];
export const UNCERTAINTY_DISTRIBUTIONS = [
  { value: 'normal', label: 'Normal (÷ k)' },
  { value: 'rectangular', label: 'Rectangular (÷ √3)' },
  { value: 'resolution', label: 'Resolution (½ ÷ √3)' },
  { value: 'triangular', label: 'Triangular (÷ √6)' },
  { value: 'u_shaped', label: 'U-shaped (÷ √2)' },
  { value: 'standard', label: 'Standard uncertainty (÷ 1)' },
  { value: 'custom', label: 'Custom divisor' },
];
export const UNCERTAINTY_BASES = [
  { value: 'absolute', label: 'Same unit as the reading' },
  { value: 'pct_reading', label: '% of reading' },
  { value: 'ppm_reading', label: 'ppm of reading' },
  { value: 'pct_fs', label: '% of full scale' },
];
export const UNCERTAINTY_LINE_KINDS = [
  { value: 'masterCertificate', label: 'Master certificate uncertainty', distribution: 'normal' },
  { value: 'masterAccuracy', label: 'Master accuracy', distribution: 'rectangular' },
  { value: 'masterResolution', label: 'Master resolution', distribution: 'resolution' },
  { value: 'uucResolution', label: 'Resolution of the instrument', distribution: 'resolution' },
  { value: 'stability', label: 'Stability / drift', distribution: 'rectangular' },
  { value: 'uniformity', label: 'Uniformity / bath stability', distribution: 'rectangular' },
  { value: 'temperature', label: 'Temperature effect', distribution: 'rectangular' },
  { value: 'hysteresis', label: 'Hysteresis', distribution: 'rectangular' },
  { value: 'other', label: 'Other', distribution: 'rectangular' },
];
export const UNCERTAINTY_AUTO_TEMPLATE = 'auto';
export const UNCERTAINTY_TEMPLATES = [
  // Only the sources this form has fields for; nothing to fill in.
  {
    value: UNCERTAINTY_AUTO_TEMPLATE,
    label: 'Automatic (from this form)',
    lines: ['masterCertificate', 'masterAccuracy', 'uucResolution'],
    auto: true,
  },
  {
    value: 'pressure',
    label: 'Pressure gauge / transmitter',
    lines: ['masterCertificate', 'masterAccuracy', 'uucResolution'],
  },
  {
    value: 'indicator',
    label: 'Indicator / controller fed by a calibrator',
    lines: ['masterCertificate', 'masterAccuracy', 'masterResolution'],
  },
  {
    value: 'meter',
    label: 'Meter read against a calibrator (e.g. DMM)',
    lines: ['masterCertificate', 'uucResolution'],
  },
  {
    value: 'temperatureSensor',
    label: 'Temperature sensor in a bath or dry block',
    lines: ['masterCertificate', 'masterResolution', 'stability', 'uniformity', 'uucResolution'],
  },
  {
    value: 'enclosure',
    label: 'Furnace / oven / bath',
    lines: ['masterCertificate', 'masterAccuracy', 'uniformity', 'stability'],
  },
  {
    value: 'dimensional',
    label: 'Dimensional (micrometer, caliper, gauge)',
    lines: ['masterCertificate', 'masterAccuracy', 'temperature', 'uucResolution'],
  },
  {
    value: 'transducer',
    label: 'Transducer / transmitter (sensitivity coefficient)',
    lines: ['masterCertificate', 'masterAccuracy', 'uucResolution'],
    sensitivity: true,
  },
  { value: 'blank', label: 'Start blank', lines: [] },
];
export const UNCERTAINTY_MODAL_TITLE = 'Uncertainty column';
export const UNCERTAINTY_FIELD_NOTE =
  'Written by Uncertainty — saving that set-up again replaces this formula.';
export const UNCERTAINTY_STATEMENT_TOKEN = 'Uncertainty.Statement';
export const UNCERTAINTY_INFO = {
  template: 'A starting set of uncertainty sources for this kind of calibration. You can change every line.',
  readings: 'The repeated readings of one test point. Their spread gives the Type A part (standard deviation ÷ √n).',
  point: 'The set point (or standard reading) of the row. Needed for lines given as % or ppm of reading.',
  lines: 'Type B sources. Each is turned into a standard uncertainty: the value is divided by its divisor (k, √3 …) and multiplied by the sensitivity coefficient.',
  k: 'Coverage factor of the expanded uncertainty. k = 2 gives about 95 % coverage.',
  rounding: 'ILAC-P14: report at most 2 significant digits, rounded up.',
  column: 'The column is written into every row of the table, with its own formula. Rows added later with “+ Add row” get it too.',
  unsaved: 'Save the form first: adding the column reloads the sheet from the server.',
};
export const UNCERTAINTY_NO_ROWS =
  'Select the rows of a reading table in the sheet, or define the table under Reading Tables first.';
// One-click (automatic) Uncertainty column.
export const UNCERTAINTY_AUTO = {
  add: 'Add Uncertainty column',
  saveAndAdd: 'Save and add',
  adding: 'Adding the Uncertainty column…',
  manual: 'Set up manually',
  hideManual: 'Hide manual set-up',
  setUp: 'Set up',
  failed: 'Could not add the Uncertainty column',
  notSaved: 'The form could not be saved, so the column was not added.',
  added: (name, col) => `Added to ${name} in column ${col}`,
  uses: 'Uses',
  readings: (n) => `${n} repeat reading${n === 1 ? '' : 's'}`,
  rule: (k, autoK) =>
    `${autoK ? 'k per row from the effective degrees of freedom' : `k = ${k}`}, rounded up to 2 significant digits`,
  companions: (n) => `${n} master value field${n === 1 ? '' : 's'} added`,
  reasons: {
    noTable:
      'No reading table found. A reading table is two or more rows with the same fields, one row per test point.',
    noReadings:
      'No readings found in the reading table. Name the reading fields like “UUC Reading 1”, “Reading 2” or “Observation 1”.',
    noMasterU:
      'No master uncertainty found. Add a Master field to the form (its value fields are created automatically), ' +
      'or a Number field auto-filled from the master → U (±).',
    tooLong:
      'The generated formula would be too long. Use fewer masters for this table (up to about 4), or set the column up manually.',
  },
};
// Dialog layout (automatic card + Customise view).
// "How Ue is worked out" — plain-language explanation in the Customise dialog.
export const UNCERTAINTY_HOW = {
  readyTail: 'worked out separately for every row',
  step1: 'Turn every source into a standard uncertainty (u)',
  step1Hint: 'value ÷ divisor',
  groupReadings: 'From the readings',
  groupReadingsHint: 'scatter of the repeated readings',
  groupInstrument: 'From the instrument under test',
  groupOther: 'Other sources',
  groupMasterHint: 'the master picked on the ticket decides what counts',
  measuresOnly: 'Counted only when the picked master measures the temperature',
  measuresWhy: '(Used As = Measuring Standard · Counts in Ue = 1)',
  always: 'Always counted',
  alwaysWhy: '(recorded for masters used as a heat source)',
  attrNames: {
    uncertainty: 'Certificate uncertainty',
    accuracy: 'Accuracy',
    resolution: 'Resolution',
    drift: 'Drift since calibration',
    uniformity: 'Uniformity',
    stability: 'Stability',
  },
  repeatability: 'Repeatability',
  spreadOf: 'spread of',
  readingsNote: (n) => `(${n} readings)`,
  halfStep: '(half a display step)',
  zeroIfMissing: '· 0 if not recorded',
  step2: 'Combine them',
  step2Hint: 'square each, add, take the square root',
  step3: 'Expand',
  step3Hint: (k) => {
    if (k === '2') return 'k = 2 gives about 95 % confidence';
    if (k === '1.96') return 'k = 1.96 gives 95 % confidence';
    return `coverage factor k = ${k}`;
  },
  step4: (digits, mode) =>
    mode === 'decimals'
      ? `Round up to ${digits} decimal place${digits === 1 ? '' : 's'}`
      : `Round up to ${digits} significant digit${digits === 1 ? '' : 's'}`,
  step4Hint: 'always rounded up, never down',
  ruleBlank: 'Ue stays blank until these are filled:',
  ruleZero: 'A master value that isn’t recorded (accuracy, drift…) counts as 0, and a warning shows while filling.',
  ruleRole:
    'A master’s certificate, accuracy, resolution and drift count only when the master picked on the ticket is a measuring standard — e.g. a reference PRT counts them, a dry block used as a heat source doesn’t.',
  copy: 'Copy formula (for Excel)',
};
// Publish reminder (NABL organisations, Calibration forms without an Uncertainty column).
export const UNCERTAINTY_PUBLISH_REMINDER = {
  title: 'No Uncertainty column yet',
  body: 'This calibration form has a reading table but no Uncertainty column, so its certificates will not state the expanded uncertainty.',
  add: 'Add Uncertainty column',
  publishAnyway: 'Publish without it',
};
export const UNCERTAINTY_UI = {
  scope: (name, rows) => `${name} · ${rows}`,
  scopeMany: (n) => `${n} reading tables`,
  readyTitle: 'Ready to add automatically',
  readySub: 'Nothing changes until you click Add',
  rounding: (digits, mode) =>
    mode === 'decimals' ? `${digits} decimals, rounded up` : `${digits} significant digits, rounded up`,
  stepColumn: (col) => `A new Ue column in column ${col} — one value per reading row`,
  heading: (text) => `Heading: ${text}`,
  stepFields: (n, master) => `${n} value field${n === 1 ? '' : 's'} for ${master}`,
  stepFieldsTail: ' — they fill from the picked master',
  stepFieldsInfo: (mode) =>
    mode === 'row'
      ? 'Added as new columns beside the master. Each one fills from the master picked while filling.'
      : 'Added in a labelled block under the form. Each one fills from the master picked while filling.',
  stepCertificate: 'Certificate tables showing these rows also get the Ue column',
  madeOf: 'Ue is made of:',
  repeatability: (labels) => `Repeatability · ${labels.join(', ')}`,
  customise: 'Customise before adding',
  cancel: 'Cancel',
  customiseTitle: 'Customise Uncertainty column',
  missingMaster: (labels) => `${labels.join(', ')} ${labels.length === 1 ? "isn't" : "aren't"} in this column yet`,
  missingMasterSub: ' — the value fields (U, k, accuracy…) aren’t on the form.',
  useAuto: 'Use automatic set-up',
  secReadings: 'Readings (Type A)',
  secSources: 'Sources (Type B)',
  secResult: 'Result column',
  repeated: 'Repeated readings of the instrument',
  repeatSwitch: 'Repeatability',
  startFrom: 'Start from',
  ready: (col, first, last) => `Ready · column ${col}, ${first} – ${last}`,
  rename: 'Rename this source',
  named: (label) => `Named: ${label}`,
  sameUnit: 'Same as reading',
  unitInfo: 'Same unit as the reading, or a share of the reading / full scale (% or ppm).',
  distributionInfo: 'How the value is spread; it sets the divisor that turns it into a standard uncertainty.',
  ciInfo: 'Sensitivity coefficient: how strongly this source moves the result. Usually 1.',
  ofReading: '% of',
  ofFullScale: '% of full scale',
  copied: 'Formula copied',
  kFrom: 'k from the certificate',
  warnNoRepeat: 'Repeatability is not part of Ue — it needs at least two reading columns.',
  noRepeatChip: 'no repeatability (one reading column)',
  warnNoMasterU:
    'No master certificate uncertainty in this column — the reference standard’s U is not part of Ue.',
  kAuto: 'Automatic (from readings)',
  kAutoHint:
    'k per row from the effective degrees of freedom (Welch–Satterthwaite): few scattered readings get a larger k. A k column is added next to Ue.',
  kAutoNoRepeat: 'Repeatability is off, so k = 2 applies to every row.',
  unitLabel: 'Reading unit',
  unitWarnInfo:
    'Optional. When set, picking a master whose ranges use a different unit shows a warning while filling.',
};
export const UNCERTAINTY_DIVISOR_TEXT = {
  rectangular: '√3',
  resolution: '2√3',
  triangular: '√6',
  u_shaped: '√2',
};
// Companion value fields one click creates beside each Master field (label = "<master> <suffix>").
export const UNCERTAINTY_COMPANION_ATTRIBUTES = [
  'uncertainty',
  'k',
  'accuracy',
  'resolution',
  'drift',
  'uniformity',
  'stability',
  'role',
];
export const UNCERTAINTY_COMPANION_SUFFIX = {
  uncertainty: 'U',
  k: 'k',
  accuracy: 'Accuracy',
  resolution: 'Resolution',
  drift: 'Drift',
  uniformity: 'Uniformity',
  stability: 'Stability',
  role: 'Counts',
};

// ----- Register: organization features -----
export const REGISTER_FEATURES_TITLE = 'Features';
export const REGISTER_FEATURES_COUNT = (on, total) => `${on} of ${total} on`;
// `parent`: the row shows (indented) only while that feature is on.
export const REGISTER_FEATURES = [
  {
    name: 'enableMachineData',
    label: 'Machine Data (Modbus / OPC-DA)',
    icon: <ApiOutlined />,
    info: 'Allows this organization to configure Sources/Tags and read live values into forms.',
  },
  {
    name: 'enableCalibrationAndLab',
    label: 'Calibration & Laboratory Forms',
    icon: <ExperimentOutlined />,
    info: 'Allows this organization to create Calibration and Laboratory forms with a Certificate section.',
  },
  {
    name: 'nablAccredited',
    label: 'NABL Accredited',
    icon: <SafetyCertificateOutlined />,
    info: 'Adds the automatic Uncertainty column for calibration forms.',
    parent: 'enableCalibrationAndLab',
  },
];

// One-click preview (shown only when fields would be created, linked or converted).
export const UNCERTAINTY_PREVIEW = {
  title: 'This will set up the Uncertainty column',
  adding: 'Adding',
  using: (label) => `Using your field: ${label}`,
  convert: 'fill it from the master',
  convertInfo:
    'Ticked: the field fills from the picked master and locks. Unticked: it stays hand-typed, ' +
    'and a warning appears while filling when the typed value differs from the master.',
  confirm: 'Add Uncertainty column',
  cancel: 'Cancel',
  blockNote: 'The value fields are added in a labelled block under the form.',
};
// Hand-field linking: a plain number field named "<master> <synonym>" is reused, never duplicated.
export const UNCERTAINTY_LINK_SYNONYMS = {
  uncertainty: ['U', 'Uncertainty', 'Unc'],
  accuracy: ['Accuracy'],
  resolution: ['Resolution', 'Least Count'],
  drift: ['Drift'],
  uniformity: ['Uniformity'],
  stability: ['Stability'],
};
export const UNCERTAINTY_SPEC_ISSUES_LABEL = 'Uncertainty data incomplete';
export const UNCERTAINTY_CROSS_CHECK = (code, recorded, typed) =>
  `Master ${code} records ±${recorded} — you entered ${typed}`;
export const UNCERTAINTY_DELETE_WARNING =
  'This field is used by the Uncertainty column — Ue will stop calculating. Delete anyway?';

// ----- Offline sync progress card -----
export const SYNC_PROGRESS_UI = {
  title: 'Synchronizing Data…',
  close: 'Hide sync progress (syncing continues)',
};
// A hidden card returns for the next sync once nothing has synced for this long.
export const SYNC_PROGRESS_REOPEN_IDLE_MS = 3000;
